import React from 'react';
import {  Show,
ShowButton,List,EditButton,SimpleForm,
 Datagrid,RichTextInput,DisabledInput,TextInput,Edit,
TextField, RichTextField ,SimpleShowLayout,TabbedForm,FormTab,Create,UrlField
 }
from 'admin-on-rest/lib/mui';

export const DapeZahavList = (props) => (
    <List title="דפי זהב" {...props}>
        <Datagrid>
            <TextField label="#" source="id" />
          
             <TextField label="query" source="query" />
             <TextField label="location" source="location" />
<UrlField label="excel"source="excelUrl" />
   <EditButton />
            <ShowButton />
        </Datagrid>
    </List>
);

const DapeZahavTitle = ({ record }) => {
    return <span>DapeZahav {record ? `"${record.query }"` : `"${record.location }"`}</span>;
};


export const DapeZahavShow = (props) => (

<Show title={<DapeZahavTitle />} {...props}>
 <SimpleShowLayout>
        <TextField label="#" source="id" />
        <TextField label="query" source="query" />
  <TextField label="location" source="location" />
<TextField label="url" source="url" />
         </SimpleShowLayout>
    </Show>
);


export const DapeZahavEdit = (props) => (
    <Edit {...props}>

        <SimpleForm>
 <DisabledInput source="id" />
<TextInput  source="url" />
<TextInput  source="query" />
<TextInput  source="location" />


        </SimpleForm>
  </Edit>
);

export const DapeZahavCreate = (props) => (
    <Create title="הוספת חיפוש חדש" {...props}>
      <SimpleForm >

              <DisabledInput label="Id" source="id" />
                <TextInput source="url" label="url"/>
      </SimpleForm>
    </Create>
);




// WEBPACK FOOTER //
// ./src/components/DapeZahav/dapezahav.js